import React, { useEffect } from 'react';
import { ThemeProvider as MUIThemeProvider, CssBaseline } from '@mui/material';
import theme from './styles/theme';
import { AuthProvider } from './contexts/AuthContext'; // Updated to AuthContext
import { LoadingProvider } from './contexts/LoadingContext'; // Updated to LoadingContext
import { CustomThemeProvider } from './contexts/ThemeContext';
import { QueryClient, QueryClientProvider } from 'react-query';
import Index2 from './routes/index2'; // Updated to use the new index2 routes
import { OnlineStatusProvider } from './contexts/OnlineStatusContext'; //  Import
import OfflineSnackbar from './components/Offline/OfflineSnackbar'; //  Import

// Initialize QueryClient with desired configuration
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 1000 * 60 * 5, // 5 minutes
      staleTime: 1000 * 60, // 1 minute
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => error.status < 500 && failureCount < 3,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30000),
    },
  },
});

const App = () => {
  // Log when the App component renders and when it unmounts (cleanup)
  useEffect(() => {
    console.log("App component mounted.");

    return () => {
      console.log("App component unmounted.");
    };
  }, []);


  return (
    <MUIThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <OnlineStatusProvider>
        {/* Router logic is handled inside Index2 */}
          <LoadingProvider> 
            <AuthProvider> 
                <CustomThemeProvider>
                  <Index2 />
                  <OfflineSnackbar /> 
                </CustomThemeProvider>
            </AuthProvider>
          </LoadingProvider>
        </OnlineStatusProvider>
      </QueryClientProvider>
    </MUIThemeProvider>
  );
};

export default App;
